import { render, staticRenderFns } from "./NoPermissions.vue?vue&type=template&id=63b95ff4&scoped=true"
import script from "./NoPermissions.vue?vue&type=script&lang=js"
export * from "./NoPermissions.vue?vue&type=script&lang=js"
import style0 from "./NoPermissions.vue?vue&type=style&index=0&id=63b95ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b95ff4",
  null
  
)

export default component.exports